import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function Field({ id, label, testId, hint, ...props }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-sm font-semibold text-ds-ink">{label}</Label>
      <Input id={id} className="h-12 rounded-xl bg-white border-ds-plum/20 text-[16px] focus-visible:ring-ds-plum" data-testid={testId} {...props} />
      {hint && <p className="text-xs text-ds-inksoft">{hint}</p>}
    </div>
  );
}

export function SubmitButton({ busy, children, testId, ...props }) {
  return (
    <button type="submit" disabled={busy} className="ds-btn w-full bg-ds-plum text-white hover:bg-[#3d0232] disabled:opacity-60" data-testid={testId} {...props}>
      {busy && <Loader2 className="h-4 w-4 animate-spin" />} {children}
    </button>
  );
}

export function FormError({ message, testId = "form-error" }) {
  if (!message) return null;
  return <p className="rounded-xl bg-rose-50 border border-rose-200 px-4 py-3 text-sm text-rose-700" data-testid={testId}>{message}</p>;
}
